// 알림 수
import { createSlice } from '@reduxjs/toolkit';
import ApiClient from 'utils/api/ApiClient';

const initialState = { count:0 };
const notificationCountSlice = createSlice({
    name: 'notificationCount',
    initialState,
    reducers: {
        change: (state, action) => {
            state.count = action.payload;
        }
    }
});


export default notificationCountSlice.reducer;
const actions = notificationCountSlice.actions;


export function changeNotificationCount(count){
	return (dispatch)=>{
		dispatch( actions.change(count) );
	};
}

export function initNotification(){
    return (dispatch)=>{
        ApiClient({
            method:'get',
            url:'/api/auth/notification',
            authToken:sessionStorage.getItem('user')
        });
    }
}